import { Component } from '@angular/core';
import { UilabMatBadgeModule, UilabMatButton } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface NotificationExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly count: string;
}

@Component({
    selector: 'avd-notification-examples',
    templateUrl: './notification-examples.component.html',
    styleUrls: ['./notification-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatButton,
        UilabMatBadgeModule,
    ],
})
export class NotificationExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-badge--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/badge`;

    readonly examples: readonly NotificationExample[] = [
        {
            variant: 'basic',
            label: 'Basic Notification Badge',
            description:
                'Use a badge on a button to show the current number of unread notifications.',
            htmlSnippet: `<button
    uilabMatButton="outlined"
    uilabMatBadge="3"
    uilabMatBadgeDescription="Unread notifications"
>
    Notifications
</button>`,
            count: '3',
        },
    ];
}
